enum StorageKey {
  InternationalAvsBannerDismissed = 'international_avs_banner_dismissed',
  InternationalAvsBannerFirstSeen = 'international_avs_banner_first_seen',
}

const getStorageKey = (
  environment: string,
  key: StorageKey,
  appId?: string,
): string => {
  return appId ? `${environment}_${key}_${appId}` : `${environment}_${key}`;
};

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

export const internationalAvsStorage = {
  isBannerDismissed: (environment: string, appId: string): boolean => {
    return (
      localStorage.getItem(
        getStorageKey(
          environment,
          StorageKey.InternationalAvsBannerDismissed,
          appId,
        ),
      ) === 'true'
    );
  },

  setBannerDismissed: (environment: string, appId: string): void => {
    localStorage.setItem(
      getStorageKey(
        environment,
        StorageKey.InternationalAvsBannerDismissed,
        appId,
      ),
      'true',
    );
  },

  initializeBannerFirstSeen: (environment: string, appId: string): void => {
    const firstSeenKey = getStorageKey(
      environment,
      StorageKey.InternationalAvsBannerFirstSeen,
      appId,
    );
    if (!localStorage.getItem(firstSeenKey)) {
      localStorage.setItem(firstSeenKey, Date.now().toString());
    }
  },

  getBannerFirstSeen: (environment: string, appId: string): number => {
    const firstSeenAt = localStorage.getItem(
      getStorageKey(
        environment,
        StorageKey.InternationalAvsBannerFirstSeen,
        appId,
      ),
    );
    return firstSeenAt ? parseInt(firstSeenAt, 10) : 0;
  },

  shouldShowBanner: (environment: string, appId: string): boolean => {
    if (internationalAvsStorage.isBannerDismissed(environment, appId)) {
      return false;
    }

    const firstSeenAt = internationalAvsStorage.getBannerFirstSeen(
      environment,
      appId,
    );
    if (!firstSeenAt) {
      return true;
    }

    const now = Date.now();
    return now - firstSeenAt <= THREE_DAYS_MS;
  }
}; 